import { render } from "./Team.vue?vue&type=template&id=0b168e5a&scoped=true&ts=true"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"

import "./Team.vue?vue&type=style&index=0&id=0b168e5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b168e5a"]])

export default __exports__